<template>
  <div>
    <container-headline
      :headline="$t('global.interests')"
      :col="6"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="form-check col-xl-4" style="padding-left: 36px">
              <input
                type="checkbox"
                v-model="interessen.hatBauernhoferfahrung"
                id="bauernhoferfahrung"
                class="form-check-input"
                :disabled="!editable"
              />
              <label>{{ $t("global.hasfarmexperience") }}</label>
            </div>
            <div class="col-xl-8" v-if="interessen.hatBauernhoferfahrung">
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="interessen.bauernhoferfahrung"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>{{ $t("global.farmexperiencedetails") }}</label>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="interessen.hobbiesInteressen"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>{{ $t("global.hobbiesandinterests") }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";

export default {
  name: "GeschaeftsparnerInteressenNewViva",
  components: {
    ContainerHeadline,
  },
  mixins: [],
  props: {
    interessen : {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>
